<div class="proto">
	<h2>Canopy curve prototype</h2>
	<p class="muted">
		Dashed gray = seed formula. Dots = fake NDVI. Blue = editable nodes and live spline.
		Save is in memory only and is what date lookup uses. Alfalfa drops at each cut.
		Scroll to zoom; drag empty chart to pan when zoomed.
	</p>

	<label class="crop">
		Crop
		<select [(ngModel)]="crop" (ngModelChange)="onCropChange()">
			<option value="lettuce">Lettuce</option>
			<option value="alfalfa">Alfalfa</option>
		</select>
	</label>

	<svg #chartSvg
		class="chart"
		[attr.viewBox]="vbX + ' ' + vbY + ' ' + vbW + ' ' + vbH"
		(click)="onPlotClick($event)"
		(wheel)="onWheel($event)">

		<rect class="plot"
			[attr.x]="pad.l"
			[attr.y]="pad.t"
			[attr.width]="plotW"
			[attr.height]="plotH"
			(mousedown)="startPan($event)" />

		<g *ngFor="let tick of yTicks">
			<line class="grid"
				[attr.x1]="pad.l"
				[attr.x2]="pad.l + plotW"
				[attr.y1]="y(tick)"
				[attr.y2]="y(tick)" />
			<text class="axis" [attr.x]="pad.l - 6" [attr.y]="y(tick) + 4">{{ tick }}</text>
		</g>

		<line *ngFor="let cut of cuts"
			class="cut"
			[attr.x1]="x(cut)"
			[attr.x2]="x(cut)"
			[attr.y1]="pad.t"
			[attr.y2]="pad.t + plotH" />

		<text class="axis start" [attr.x]="pad.l" [attr.y]="H - 8">{{ wetDate | date:'MMM d' }}</text>
		<text class="axis" [attr.x]="W - pad.r" [attr.y]="H - 8">{{ harvestDate | date:'MMM d' }}</text>
		<text class="axis" [attr.x]="8" [attr.y]="14">%</text>

		<polyline *ngFor="let pts of seedSegments" class="seed" [attr.points]="pts" />
		<ng-container *ngIf="showNdviFit">
			<polyline *ngFor="let pts of ndviFitSegments" class="ndvi-fit" [attr.points]="pts" />
		</ng-container>
		<polyline *ngFor="let pts of calculatedSegments" class="calculated" [attr.points]="pts" />

		<circle *ngFor="let p of ndvi"
			class="ndvi"
			[attr.cx]="x(p.day)"
			[attr.cy]="y(p.canopy)"
			r="4" />

		<circle *ngFor="let n of nodes; let i = index"
			class="node"
			[attr.cx]="x(n.day)"
			[attr.cy]="y(n.canopy)"
			[class.selected]="i === selectedIndex"
			r="7"
			(mousedown)="startDrag(i, $event)"
			(click)="$event.stopPropagation()">
			<title>{{ n.canopy | number:'1.1-1' }}%</title>
		</circle>
	</svg>

	<div class="row">
		<button type="button" (click)="save()">Save curve</button>
		<button type="button" (click)="zoomBy(0.8)">Zoom in</button>
		<button type="button" (click)="zoomBy(1.25)">Zoom out</button>
		<button type="button" (click)="resetView()">Reset view</button>
		<label class="toggle">
			<input type="checkbox" [(ngModel)]="showNdviFit" />
			Show NDVI fit
		</label>
		<button type="button" (click)="applyNdviFit()">Apply NDVI fit</button>
		<button type="button" (click)="reset()">Reset to seed</button>
		<button type="button"
			(click)="removeSelected()"
			[disabled]="!canRemoveSelected()">
			Remove node
		</button>
		<span class="status" *ngIf="savedNodes">Saved ({{ savedNodes.length }} nodes)</span>
		<span class="muted" *ngIf="!savedNodes">Not saved — lookup uses seed formula</span>
	</div>

	<div class="lookup">
		<h3>Get canopy for a date</h3>
		<label>
			Date
			<input type="date"
				[(ngModel)]="queryDate"
				[min]="wetInput"
				[max]="harvestInput" />
		</label>
		<button type="button" (click)="calculate()">Calculate</button>
		<p *ngIf="queryResult !== null">
			<strong>{{ queryResult | number:'1.1-1' }}%</strong>
			<span class="muted">
				{{ queryUsedCustom ? 'from saved calculated curve' : 'from seed formula (A/B)' }}
			</span>
		</p>
	</div>
</div>
